export const UNITS2FORMATTING = {
    W: '%.0f W',
    kWh: '%.0f kWh',
    Wh: '%.0f Wh',
    A: '%.1f A',
    VDC: '%.2f V',
    VAC: '%.0f V',
    PERCENTAGE: '%.0f %%',
    SOC: '%.1f %%',
};

/**
 * Used for displaying outdated or empty values on the dashboard
 * @type {string}
 */
export const INVALID_VALUE = '-';

/**
 * Returns true if the timestamp is not older than 24h
 * @param timestamp
 * @returns {boolean}
 */
export function isValueOutdated(timestamp) {
    return Date.now() / 1000 - timestamp > 60 * 60 * 24;
}

/**
 * Compares two values by the rules that installation attributes have their values compared.
 * This comparator deals with nulls by sorting them down and tries to interpret numbers in strings.
 * For use with Array.prototype.sort() and the like.
 * @param a
 * @param b
 * @returns {number}
 */
export function attributeValueComparator(a, b) {
    // Empty checks
    const emptyA = a === undefined || a === null;
    const emptyB = b === undefined || b === null;
    if (emptyA && emptyB) {
        return 0;
    } else if (emptyA) {
        return -1;
    } else if (emptyB) {
        return 1;
    }

    // Booleans
    if (typeof a === 'boolean' && typeof b === 'boolean') {
        return a && !b ? -1 : !a && b ? 1 : 0;
    }

    // Numbers
    if (!isNaN(a) && !isNaN(b)) {
        const floatA = parseFloat(a);
        const floatB = parseFloat(b);
        return floatA - floatB;
    }

    // Strings
    const stringA = a.toString().toLowerCase();
    const stringB = b.toString().toLowerCase();
    if (stringA > stringB) {
        return 1;
    } else if (stringA < stringB) {
        return -1;
    } else {
        return 0;
    }
}

/**
 * Compares two values by the rules that installation attributes have their values compared.
 * This comparator deals with nulls by sorting them down and tries to interpret numbers in strings.
 * For use with Array.prototype.sort() and the like.
 * @param a
 * @param b
 * @returns {number}
 */
export function attributeValueComparatorWithSorter(a, b, sortedReverse) {
    const sortValue = sortedReverse ? -1 : 1;

    // Empty checks
    const emptyA = a === undefined || a === null;
    const emptyB = b === undefined || b === null;
    if (emptyA && emptyB) {
        return 0;
    } else if (emptyA) {
        return 1;
    } else if (emptyB) {
        return -1;
    }

    // Booleans
    if (typeof a === 'boolean' && typeof b === 'boolean') {
        return a && !b ? -sortValue : !a && b ? sortValue : 0;
    }

    // Numbers
    if (!isNaN(a) && !isNaN(b)) {
        const floatA = parseFloat(a);
        const floatB = parseFloat(b);
        return sortValue * (floatA - floatB);
    }

    // Strings
    const stringA = a.toString().toLowerCase();
    const stringB = b.toString().toLowerCase();
    if (stringA > stringB) {
        return sortValue;
    } else if (stringA < stringB) {
        return -sortValue;
    } else {
        return 0;
    }
}
